import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../api";
import Logo from "../../images/logo-2.png";
import add from "../../images/add.png";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";
import './AddPost.css'

function AddPost({ match }) {
  const adminStore = useSelector((state) => state.adminReducer);

  const [value, setValue] = useState("");
  const [title, setTitle] = useState("");
  const [loader, setLoader] = useState(false);
  const [selectedImg, setSelectedImg] = useState([]);
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [inputData, setInputData] = useState({
    description: "",
    img: "",
    format: "",
  });

  const handleSubmit = async () => {
    try {
      if (inputData.description) {
        setLoader(true);
        let payload = {
          _id: adminStore.admin.admin._id,
          description: inputData.description,
          video: inputData?.video || "",
          pdfFile: inputData?.pdfFile || "",
          imageTitle: inputData.img || "",
          imageFormat: inputData.format || "",
        };
        const signalResponse = await api.postCreate(payload);

        if (signalResponse?.success) {
          alert("Post created successfully");
          setInputData({
            description: "",
            img: "",
            format: "",
            video: "",
            pdfFile: "",
          });
          setLoader(false);
          setSelectedImg([]);
          setSelectedPDF(null);
        } else {
          setLoader(false);
          alert("Something went wrong");
        }
      } else {
        setLoader(false);
        alert("Please insert description");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong");
    }
  };

  const sendNotification = async () => {
    try {
      const signalResponse = await api.sendPostMailToAllUser();
      if (signalResponse?.success) {
        alert("email sent to all users");
      }
    } catch (error) {
      alert("Something went wrong");
    }
  };

  var Editor = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  const onFileChange = async (e) => {
    try {
      setLoader(true);
      if (!e.target.files) {
        return;
      }
      const formData = new FormData();
      for (let file of e.target.files) {
        formData.append("image", file);
      }
      const uploadRes = await api.uploadFile(formData);
      let sImage = [];
      var imgName = uploadRes[0].split(",");
      var imgFormat = uploadRes[1].split(",");
      for (let i = 0; i < imgName.length; i++) {
        sImage.push(
          `${process.env.REACT_APP_S3URL}/img_${imgName[i]}.${imgFormat[i]}`
        );
      }
      setSelectedImg(sImage);
      setInputData({
        ...inputData,
        img: uploadRes[0],
        format: uploadRes[1],
      });
      setLoader(false);
    } catch (e) {
      alert("File upload failed");
      setLoader(false);
      console.log(e.message);
    }
  };

  const onPDFChange = async (e) => {
    try {
      setLoader(true);
      const formData = new FormData();
      formData.append("pdf", e.target.files[0], e.target.files[0].name);
      const uploadRes = await api.uploadPDF(formData);
      setSelectedPDF(`${process.env.REACT_APP_S3URL}/${uploadRes}`);
      setInputData({
        ...inputData,
        pdfFile: `${uploadRes}`,
      });
      setLoader(false);
    } catch (e) {
      alert("File upload failed");
      setLoader(false);
      console.log(e.message);
    }
  };

  const handleChange = (e) => {
    setInputData({ ...inputData, description: e });
  };

  const removeImage = (index) => {
    const newImages = [...selectedImg];
    newImages.splice(index, 1);
    setSelectedImg(newImages);
    
    // Update the image data strings
    const imgArray = inputData.img.split(",");
    const formatArray = inputData.format.split(",");
    imgArray.splice(index, 1);
    formatArray.splice(index, 1);
    
    setInputData({
      ...inputData,
      img: imgArray.join(","),
      format: formatArray.join(","),
    });
  };

  const removePDF = () => {
    setSelectedPDF(null);
    setInputData({
      ...inputData,
      pdfFile: "",
    });
  };

  return (
    <>
      <div className="container-fluid add-signal-container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12">
            {/* Header Section */}
            <div className="add-signal-header">
              <div className="header-content">
                <div className="title-section">
                  <h1 className="add-signal-title">
                    <i className="fas fa-bullhorn add-signal-icon"></i>
                    Add New Signal
                  </h1>
                  <p className="add-signal-subtitle">
                    Create and share trading signals with your community
                  </p>
                </div>
                <div className="header-stats">
                  <div className="stat-item">
                    <div className="stat-icon">
                      <i className="fas fa-image"></i>
                    </div>
                    <div className="stat-content">
                      <span className="stat-number">{selectedImg.length}</span>
                      <span className="stat-label">Images</span>
                    </div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-icon">
                      <i className="fas fa-file-alt"></i>
                    </div>
                    <div className="stat-content">
                      <span className="stat-number">{selectedPDF ? 1 : 0}</span>
                      <span className="stat-label">Files</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Form Card */}
            <div className="add-signal-card">
              {/* Description Editor */}
              <div className="form-section">
                <div className="form-section-header">
                  <div className="section-title">
                    <h3 className="section-title-text">
                      <i className="fas fa-align-left me-2"></i>
                      Signal Description
                    </h3>
                    <p className="section-subtitle">
                      Write detailed analysis and trading instructions
                    </p>
                  </div>
                  <div className="section-status">
                    <span className={`status-badge ${inputData.description ? 'status-active' : 'status-inactive'}`}>
                      {inputData.description ? "✓ Ready" : "Required"}
                    </span>
                  </div>
                </div>
                <div className="description-editor-container">
                  <ReactQuill
                    placeholder="Start writing your signal analysis here..."
                    modules={Editor}
                    theme="snow"
                    value={inputData.description}
                    onChange={handleChange}
                    className="signal-editor"
                  />
                  <div className="editor-tips">
                    <i className="fas fa-lightbulb"></i>
                    <span>Use headings, bullet points, and formatting for better readability</span>
                  </div>
                </div>
              </div>

              {/* Video Embed Section */}
              <div className="form-section">
                <div className="form-section-header">
                  <div className="section-title">
                    <h3 className="section-title-text">
                      <i className="fas fa-video me-2"></i>
                      Video Embed (Optional)
                    </h3>
                    <p className="section-subtitle">
                      Add iframe code for embedded videos
                    </p>
                  </div>
                </div>
                <div className="video-input-container">
                  <div className="input-with-icon">
                    <i className="fas fa-code"></i>
                    <textarea
                      name="video"
                      className="form-control video-iframe-input"
                      value={inputData.video || ""}
                      onChange={(e) =>
                        setInputData({ ...inputData, video: e.target.value })
                      }
                      placeholder='Paste iframe code here (e.g., &lt;iframe src="..."&gt;)'
                      rows="3"
                    />
                  </div>
                  <div className="input-tips">
                    <i className="fas fa-info-circle"></i>
                    <span>Copy the embed iframe code from YouTube or other video platforms</span>
                  </div>
                </div>
              </div>

              {/* Image Upload Section */}
              <div className="form-section">
                <div className="form-section-header">
                  <div className="section-title">
                    <h3 className="section-title-text">
                      <i className="fas fa-images me-2"></i>
                      Upload Images (Optional)
                    </h3>
                    <p className="section-subtitle">
                      Add charts, screenshots, or supporting images
                    </p>
                  </div>
                  <div className="section-status">
                    <span className="image-count">{selectedImg.length} selected</span>
                  </div>
                </div>
                <div className="image-upload-container">
                  <label className="image-upload-card">
                    <input
                      name="file"
                      onChange={onFileChange}
                      accept="image/*"
                      type="file"
                      multiple
                      className="image-upload-input"
                    />
                    <div className="upload-card-content">
                      <div className="upload-icon">
                        <i className="fas fa-cloud-upload-alt"></i>
                      </div>
                      <div className="upload-text">
                        <h4>Click to upload images</h4>
                        <p>PNG, JPG, GIF up to 5MB each</p>
                      </div>
                      <div className="upload-hint">
                        <i className="fas fa-mouse-pointer"></i>
                        <span>Drag & drop or click to browse</span>
                      </div>
                    </div>
                  </label>
                  
                  {/* Selected Images Preview */}
                  {selectedImg.length > 0 && (
                    <div className="image-preview-section">
                      <div className="preview-header">
                        <h4>Selected Images</h4>
                        <span className="preview-count">{selectedImg.length} images</span>
                      </div>
                      <div className="image-preview-grid">
                        {selectedImg.map((val, key) => (
                          <div className="image-preview-card" key={key}>
                            <img className="preview-image" src={val} alt={`Preview ${key + 1}`} />
                            <button 
                              className="remove-image-btn"
                              onClick={() => removeImage(key)}
                              title="Remove image"
                            >
                              <i className="fas fa-times"></i>
                            </button>
                            <div className="image-overlay">
                              <span className="image-number">Image {key + 1}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* File Upload Section */}
              <div className="form-section">
                <div className="form-section-header">
                  <div className="section-title">
                    <h3 className="section-title-text">
                      <i className="fas fa-file-upload me-2"></i>
                      Upload Document (Optional)
                    </h3>
                    <p className="section-subtitle">
                      Add PDF or Word documents for detailed analysis
                    </p>
                  </div>
                </div>
                <div className="file-upload-container">
                  {!selectedPDF ? (
                    <label className="file-upload-card">
                      <input
                        name="file"
                        onChange={onPDFChange}
                        accept=".pdf,.doc,.docx"
                        type="file"
                        className="file-upload-input"
                      />
                      <div className="upload-card-content">
                        <div className="upload-icon">
                          <i className="fas fa-file-upload"></i>
                        </div>
                        <div className="upload-text">
                          <h4>Click to upload document</h4>
                          <p>PDF or Word documents up to 10MB</p>
                        </div>
                        <div className="file-types">
                          <span className="file-type-badge pdf-badge">
                            <i className="fas fa-file-pdf"></i> PDF
                          </span>
                          <span className="file-type-badge word-badge">
                            <i className="fas fa-file-word"></i> DOC
                          </span>
                          <span className="file-type-badge word-badge">
                            <i className="fas fa-file-word"></i> DOCX
                          </span>
                        </div>
                      </div>
                    </label>
                  ) : (
                    <div className="file-preview-card">
                      <div className="file-preview-content">
                        <div className="file-icon">
                          {inputData?.pdfFile?.includes(".pdf") ? (
                            <i className="fas fa-file-pdf pdf-icon"></i>
                          ) : (
                            <i className="fas fa-file-word word-icon"></i>
                          )}
                        </div>
                        <div className="file-info">
                          <h5 className="file-name">
                            {inputData?.pdfFile?.split("_")[0] || "Uploaded File"}
                          </h5>
                          <p className="file-size">Ready for upload</p>
                        </div>
                        <div className="file-actions">
                          <a
                            href={selectedPDF}
                            download={inputData?.pdfFile}
                            className="file-action-btn download-btn"
                            title="Download file"
                          >
                            <i className="fas fa-download"></i>
                          </a>
                          <button
                            className="file-action-btn remove-btn"
                            onClick={removePDF}
                            title="Remove file"
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Submit Section */}
              <div className="submit-section">
                <div className="submit-content">
                  <div className="submit-info">
                    <h4 className="submit-title">Ready to Publish Signal</h4>
                    <p className="submit-description">
                      Review your signal and click publish to share with your community
                    </p>
                  </div>
                  <div className="submit-actions">
                    <button 
                      className="btn-cancel"
                      onClick={() => {
                        if (window.confirm("Are you sure? All unsaved changes will be lost.")) {
                          setInputData({
                            description: "",
                            img: "",
                            format: "",
                            video: "",
                            pdfFile: "",
                          });
                          setSelectedImg([]);
                          setSelectedPDF(null);
                        }
                      }}
                    >
                      <i className="fas fa-times"></i>
                      Clear All
                    </button>
                    <button 
                      onClick={handleSubmit} 
                      className="btn-submit"
                      disabled={!inputData.description || loader}
                    >
                      {loader ? (
                        <>
                          <i className="fas fa-spinner fa-spin"></i>
                          Publishing...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-paper-plane"></i>
                          Publish Signal
                        </>
                      )}
                    </button>
                  </div>
                </div>
                <div className="submit-footer">
                  <div className="footer-item">
                    <i className="fas fa-shield-alt"></i>
                    <span>Your signal will be visible to all users</span>
                  </div>
                  <div className="footer-item">
                    <i className="fas fa-bell"></i>
                    <span>Users will receive email notifications</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loader && (
        <div className="signal-loader-overlay">
          <div className="signal-loader">
            <div className="loader-spinner">
              <i className="fas fa-chart-line fa-spin"></i>
            </div>
            <div className="loader-text">
              <h4>Publishing Signal</h4>
              <p>Please wait while we process your signal...</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddPost;


